// removed by extract-text-webpack-plugin
module.exports = {"pax-button":"PaxButton_pax-button---sbox","paxButton":"PaxButton_pax-button---sbox","with-text":"PaxButton_with-text---sbox","withText":"PaxButton_with-text---sbox","remove":"PaxButton_remove---sbox","plus":"PaxButton_plus---sbox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PaxPart/PaxButton/styles.less
// module id = 537
// module chunks = 0